import { LOGO } from "assets/seller-assets";
import classNames from "classnames";
import { topNavbarBreakpoint } from "config";
import handleNavbarTransparency from "helpers/handleNavbarTransparency";
import { useAppContext } from "Main";
import React, { useEffect, useState } from "react";
import { Container, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import LandingRightSideNavItem from "./LandingRightSideNavItem";

const NavbarStandard = () => {
  const {
    config: { isDark },
  } = useAppContext();
  const [navbarCollapsed, setNavbarCollapsed] = useState(true);

  useEffect(() => {
    window.addEventListener("scroll", handleNavbarTransparency);
    return () => window.removeEventListener("scroll", handleNavbarTransparency);
  }, []);

  return (
    <Navbar
      variant={"light"}
      fixed="top"
      expand={topNavbarBreakpoint}
      className={classNames("navbar-standard navbar-theme bg-light", {
        "bg-100": !navbarCollapsed && isDark,
        "bg-dark": !navbarCollapsed && !isDark,
      })}
    >
      <Container>
        <Navbar.Brand className="text-white" as={Link} to="/">
          <img className="me-2" src={LOGO} alt="Logo" width={120} />
        </Navbar.Brand>
        <Navbar.Toggle onClick={() => setNavbarCollapsed(!navbarCollapsed)} />
        {/* <Flex alignItems="center" className="gap-2">
          <ThemeControlDropdown dropdownClassName="d-lg-none" />
        </Flex> */}
        <Navbar.Collapse className="scrollbar">
          {/* <Nav>
            <NavbarTopDropDownMenus setNavbarCollapsed={setNavbarCollapsed} />
          </Nav> */}
          <LandingRightSideNavItem />
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarStandard;
